<template>
    <section id="mainContainer">
        <adminHeader></adminHeader>
        <section class="admin-mid-container">
            <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
                <adminNavigation></adminNavigation>

                <section class="admin-right-sidebar">
                    <div class="admin-right-sidebar-in">
                        <div class="admin-right-sidebar-in-top">
                            <div class="admin-custom-row">
                                <div class="admin-right-sidebar-in-top-left">
                                    <h1>{{ constants.MANAGE_BANNER_TEXT }}</h1>

                                    <div class="admin-page-type-links">
                                        <ul>
                                            <li>
                                                <a id="allLink" href="#" :class="{ active: activeTab === 'all' }"
                                                    @click="switchView('all')">
                                                    {{ constants.ALL_LINK }}
                                                    <span>{{ counts.all }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="publishedhLink" href="#"
                                                    :class="{ active: activeTab === 'published' }"
                                                    @click="switchView('published')">
                                                    {{ constants.PUBLISHED_LINK }}
                                                    <span>{{ counts.published }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="unPublishedhLink" href="#"
                                                    :class="{ active: activeTab === 'unpublished' }"
                                                    @click="switchView('unpublished')">
                                                    {{ constants.UNPUBLISHED_LINK }}
                                                    <span>{{ counts.unpublished }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="admin-right-sidebar-in-top-right">
                                    <div class="admin-right-sidebar-in-top-right-top">
                                        <div class="admin-search-box">
                                            <input id="seachBannerInput" type="text" placeholder="Search Banner"
                                                v-model="searchedText"
                                                @keyup.enter="fetchBanners(activeTab), fetchCounts(searchedText)" />
                                        </div>
                                        <div class="admin-add-btn">
                                            <button id="addBannerBtn" class="add-btn-admin" :class="{ 'active': showAddForm }"
                                                @click="showAddForm = true, selectedBanners = [], selectAll = false, cancelEdit()">
                                                <i class="add-icon"></i> 
                                                {{ constants.ADD_BANNER_BUTTON }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="admin-right-sidebar-in-top-right-btm" v-if="selectedBanners.length > 1">
                                        <div class="tags">
                                            <ul>
                                                <li>
                                                    <span>{{ selectedBanners.length }} entries selected</span>
                                                    <button id="tagCloseBtn"
                                                        @click="selectedBanners = [], selectAll = false"></button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="delete-all-btn-link">
                                            <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal"
                                                data-bs-target="#deletePop" @click="setDeleteMode('all')">
                                                {{ constants.DELETE_ALL_BUTTON }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showAddForm" class="white-bg-border add-new-section">
                            <div class="add-banner-image-section">
                                <h2>{{ constants.ADD_NEW_BANNER_TEXT }}</h2>
                                <div class="add-banner-image-box">
                                    <form id="addBannerImageForm" @submit.prevent="submitForm">

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.PAGE_LABEL }}

                                            </label>
                                            <select id="bnrPgSelectPageSelectBox" class="admin-selectbox"
                                                v-model="newBanner.selectedPage">
                                                <option value="">Select Page</option>
                                                <option v-for="(value, key) in pageChoices" :key="key" :value="value">{{
                                                    key }}</option>
                                            </select>
                                            <div class="error-msg" v-if="!newBanner.selectedPage">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.TITLE_LABEL }}
                                            </label>
                                            <ckeditor id="bnrPgTitleInput" type="text" v-model="newBanner.title" :editor="editor"
                                                placeholder="Enter the Title" :config="editorConfig"></ckeditor>
                                            <div class="error-msg" v-if="!newBanner.title">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.BANNER_IMAGE_LABEL }}
                                            </label>
                                            <div class="image-upload-input upload-banner-image">
                                                <div
                                                    :class="['image-upload-input-item', { 'uploaded-done': imageUploaded }]">
                                                    <div class="file-input-box">
                                                        <input id="bnrPgFileInput" type="file"
                                                            @change="handleFileUpload($event, false)"
                                                            accept="image/jpeg,image/jpg,image/png" />
                                                    </div>
                                                    <div class="image-upload-input-item-in" v-if="!imageUploaded">
                                                        <div class="image-upload-input-item-icon">
                                                            <img src="@/assets/images/admin-img/image-icon.svg"
                                                                alt="" />
                                                        </div>
                                                        <span>
                                                            {{ constants.ADD_BANNER_IMAGE_LABEL }}
                                                        </span>
                                                    </div>
                                                    <div class="image-upload-input-item-uploaded" v-if="imageUploaded">
                                                        <img :src="imageUrl" alt="" class="mCS_img_loaded">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="error-msg" v-if="!selectedFile">{{ errMsg }}</div>
                                        </div>
                                        <div class="admin-input-field-submit">
                                            <button id="bnrPgSubmitBtn" type="submit"
                                                class="admin-btn-outline-primary add-new-cancel" :disabled="isSubmitting">{{
                                                    constants.SUBMIT_BUTTON }}</button>
                                            <button id="bnrPgCancelBtn" type="button"
                                                class="admin-btn-outline-secondary add-new-cancel"
                                                @click="cancelForm">{{
                                                    constants.CANCEL_BUTTON }}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div :class="['admin-item-list-section banner-image-section', { 'show-edit-item-outer': editFormSubmitted }]"
                            v-if="editBannersData.length > 0">
                            <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                                <div class="admin-item-list-section-scroll">
                                    <div class="admin-item-list-top">
                                        <div class="admin-item-list-row">
                                            <div class="admin-item-checkbox">
                                                <div class="admin-checkbox-input">
                                                    <input name="cssCheckbox" id="selectAll" type="checkbox"
                                                        class="css-checkbox" @change="toggleSelectAll"
                                                        :checked="selectAll === true" />
                                                    <label for="selectAll"></label>
                                                </div>
                                            </div>
                                            <div class="admin-item-banner-image">{{ constants.BANNER_IMAGE_LABEL }}
                                            </div>
                                            <div class="admin-item-page-name">{{ constants.PAGE_LABEL }}</div>
                                            <div class="admin-item-title">{{ constants.TITLE_LABEL }}</div>
                                            <div class="admin-item-actions">{{ constants.ACTIONS_LABEL }}</div>
                                        </div>
                                    </div>
                                    <div class="admin-item-list-btm">
                                        <!-- <div class="admin-item-box"> -->
                                            <div ref="sortableList">
                                        <div v-for="(banner, index) in editBannersData" :key="banner.id"
                                            :class="['admin-item-box', { 'show-edit-item': editFormSubmitted }]">
                                            <div class="admin-item-box-top">
                                                <div class="admin-item-list-row">
                                                    <div class="admin-item-checkbox">
                                                        <div class="admin-checkbox-input">
                                                            <input name="cssCheckbox" :id="'demo_opt_' + banner.id"
                                                                type="checkbox" class="css-checkbox"
                                                                @change="toggleBannerSelection(banner.id)"
                                                                :checked="selectedBanners.includes(banner.id)">
                                                            <label :for="'demo_opt_' + banner.id"></label>
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-banner-image">
                                                        <div class="admin-item-banner-image-box">
                                                            <img :src="getCdnImageAddress(banner.bannerImage , `w_76,h_37/`) || '@/assets/images/admin-img/demo-img/item-img-1.jpg'"
                                                                alt="" />
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-page-name text-limit">{{ banner.selectedPage
                                                        }}
                                                    </div>
                                                    <div class="admin-item-title text-limit">
                                                            {{ useStripHtml(banner.title) }}
                                                            </div>

                                                    <div class="admin-item-actions">
                                                        <ul class="admin-action-link">
                                                            <li><button id="bnrPgEditBtn" class="editBtn"
                                                                    @click="editBanner(index), showAddForm = false">{{
                                                                        constants.EDIT_BUTTON
                                                                    }}</button></li>
                                                            <li>
                                                                <button id="bnrPgDeleteBtn" data-bs-toggle="modal"
                                                                    data-bs-target="#deletePop"
                                                                    @click="setDeleteMode('single', banner.id), showAddForm = false, cancelEdit()">
                                                                    {{ constants.DELETE_BUTTON }}
                                                                </button>
                                                            </li>

                                                            <li><button id="bnrPgUnPublishBtn"
                                                                    class="primary-outline-btn"
                                                                    v-if="banner.status === 1"
                                                                    @click="changeBannerStatus(banner.id, 0)">
                                                                    {{ constants.UNPUBLISH_BUTTON }}
                                                                </button>
                                                                <button id="bnrPgPublishBtn" class="primary-outline-btn"
                                                                    v-else-if="banner.status === 0"
                                                                    @click="changeBannerStatus(banner.id, 1)">
                                                                    {{ constants.PUBLISH_BUTTON }}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="admin-item-box-btm" v-if="banner.editing">
                                                <div class="add-banner-image-section">
                                                    <h2> {{ constants.EDIT_BANNER_TEXT }}</h2>
                                                    <div class="add-banner-image-box">
                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.PAGE_LABEL }}
                                                            </label>
                                                            <select id="bnrPgSelectPageSelectBox"
                                                                class="admin-selectbox"
                                                                v-model="editBannerData.selectedPage">
                                                                <option value="">Select Page</option>
                                                                <option v-for="(value, key) in pageChoices" :key="key"
                                                                    :value="value">{{ key }}</option>
                                                            </select>
                                                            <div class="error-msg" v-if="!editBannerData.selectedPage">
                                                                {{ errEditMsg }}</div>

                                                            <!-- <select id="bnrPgSelectPageSelectBox"
                                                                class="admin-selectbox">
                                                                <option>Select Page</option>
                                                            </select> -->
                                                        </div>
                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.TITLE_LABEL }}
                                                            </label>
                                                            <ckeditor id="bnrPgEditTitleInput" v-model="editBannerData.title" :editor="editor" placeholder="Enter the Title" :config="editorConfig"></ckeditor>
                                                            <div class="error-msg" v-if="!editBannerData.title">
                                                                {{ errEditMsg }}</div>
                                                        </div>
                                                        <div class="admin-input-field">
                                                            <label>{{ constants.BANNER_IMAGE_LABEL }}
                                                            </label>
                                                            <div class="image-upload-input upload-banner-image">
                                                                <div class="image-upload-input-item uploaded-done">
                                                                    <div class="file-input-box">
                                                                        <input id="bnrPgFileInput" type="file"
                                                                            @change="handleFileUpload($event, true)"
                                                                            accept="image/jpeg,image/jpg,image/png" />
                                                                    </div>
                                                                    <div class="image-upload-input-item-uploaded">
                                                                        <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="admin-input-field-submit">
                                                            <button id="bnrPgSubmitBtn"
                                                                class="admin-btn-outline-primary"
                                                                @click="submitEditForm(banner.id)">
                                                                {{ constants.SUBMIT_BUTTON }}
                                                            </button>
                                                            <button id="bnrPgCancelBtn"
                                                                class="admin-btn-outline-secondary addNewCancel"
                                                                @click="cancelEdit">
                                                                {{ constants.CANCEL_BUTTON }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="admin-pagination-section">
                                <div class="custom-row">
                                    <div class="item-show-selectbox">
                                        <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                                    </div>
                                    <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                                        <ul>
                                            <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                                                <a href="#" class="pagination-previous"></a>
                                            </li>
                                            <li v-for="page in visiblePages" :key="page" @click="changePage(page)"
                                                v-if="totalPages != 1">
                                                <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                            </li>
                                            <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                                                <a href="#" class="pagination-next"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p>No data to display</p>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <footer class="admin-site-footer">
            <div class="container">
                {{ constants.COPYRIGHT_TEXT }}
            </div>
        </footer>
        <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
            aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="confirmation-popup-icon">
                        <i>
                            <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
                        </i>
                    </div>
                    <div class="confirmation-popup-mid">
                        <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmDelete">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick } from 'vue';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import axios from 'axios';
import Swal from 'sweetalert2';
import { PageChoices } from '@/enums/PageChoices';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';

import Sortable, { SortableEvent } from 'sortablejs';

interface Banner {
    id: number;
    selectedPage: string;
    title: string;
    bannerImage: string;
    status: number;
    editing?: boolean;
    Created_at?: string
    position: number; // Add position field
}
export default defineComponent({
    name: "Banners",
    data() {
        return {
            constants: constants,
            activeTab: 'all',
            errMsg: '',
            searchTempVar: '',
            errEditMsg: '',
            imageSrc: '',
            editimageSrc: '',
            showAddForm: false,
            limit: 10,
            selectedFile: null as File | null,
            selectedEditFile: null as File | null,
            imageUploaded: false,
            selectAll: false,
            editFormSubmitted: false,
            banners: [] as Banner[],
            editBannersData: [] as Banner[],
            selectedBanners: [] as number[],
            totalPages: 0,
            currentPage: 1,
            searchedText: '',
            counts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            newBanner: {
                selectedPage: '',
                title: '',
                bannerImage: ''
            },
            editBannerData: {
                selectedPage: '',
                title: '',
                bannerImage: ''
            },
            editor: ClassicEditor,
    editorConfig: {
        toolbar: {
                    items: [
                        'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'undo', 'redo', '|', 'insertTable',
                    ]
                },
      fontColor: {
        colors: [
          { color: '#000000', label: 'Black' },
          { color: '#FFFFFF', label: 'White' },
          { color: '#FF0000', label: 'Red' },
          { color: '#00FF00', label: 'Green' },
          { color: '#0000FF', label: 'Blue' },
          { color: '#FFFF00', label: 'Yellow' },
          { color: '#FF00FF', label: 'Magenta' },
          { color: '#00FFFF', label: 'Cyan' },
        ],
        columns: 4,
      },
      fontBackgroundColor: {
        colors: [
          { color: '#000000', label: 'Black' },
          { color: '#FFFFFF', label: 'White' },
          { color: '#FF0000', label: 'Red' },
          { color: '#00FF00', label: 'Green' },
          { color: '#0000FF', label: 'Blue' },
          { color: '#FFFF00', label: 'Yellow' },
          { color: '#FF00FF', label: 'Magenta' },
          { color: '#00FFFF', label: 'Cyan' },
        ],
        columns: 4,
      }
    },
        // ... other data properties ...
    
            bannerToDelete: null as number | null,
            deleteMode: 'all' as 'all' | 'single',
            pageChoices: PageChoices,
            isSubmitting: false,
            isDragging: false, // Add for drag state
            sortableInstance: null as Sortable | null , // Add for SortableJS instance
            // editor: ClassicEditor,
        };
    },
    beforeRouteEnter(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== "true") {
            next({ name: 'Login' });
        } else {
            next();
        }
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        editImage(): string {
            return this.editimageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        visiblePages() {
            const maxVisiblePages = 5;
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
            let end = start + maxVisiblePages - 1;

            if (end > this.totalPages) {
                end = this.totalPages;
                start = Math.max(end - maxVisiblePages + 1, 1);
            }

            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
    },
    components: {
        adminHeader,
        adminNavigation
    },
    created() {
        this.fetchCounts();
        this.fetchBanners();
    },
    
    mounted() {
    this.setupSortable(); // Initialize SortableJS on mount
    },

    methods: {
        setDeleteMode(mode: any, bannerId?: number) {
            this.deleteMode = mode;
            if (bannerId !== undefined) {
                this.bannerToDelete = bannerId;
            }
        },
        confirmDelete() {
            if (this.deleteMode === 'all') {
                this.deleteSelectedContacts();
            } else if (this.deleteMode === 'single') {
                this.deleteBanner();
            }
        },
        changePage(page: number) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.selectAll = false
                this.selectedBanners = []
            }
        },

        handleFileUpload(event: any, isEdit: boolean = false) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        if (isEdit) {
                            this.editimageSrc = e.target.result;
                            this.selectedEditFile = file;
                        } else {
                            this.imageSrc = e.target.result;
                            this.selectedFile = file;
                            this.imageUploaded = true
                        }
                    }
                };
            }
        },
        toggleBannerSelection(bannerId: number) {
            if (this.selectedBanners.includes(bannerId)) {
                this.selectedBanners = this.selectedBanners.filter(id => id !== bannerId);
            } else {
                this.selectedBanners.push(bannerId);
            }


        },
        toggleSelectAll() {
            if (this.selectAll === true) {
                this.selectedBanners = [];
                this.selectAll = false
            } else {
                this.selectedBanners = this.editBannersData.map(banner => banner.id);
                this.selectAll = true
            }
        },

        async submitForm() {
    if (!this.newBanner.selectedPage || !this.newBanner.title || !this.selectedFile) {
        this.errMsg = "This Field Is Required";
        return;
    }
    this.isSubmitting = true;
    const formData = new FormData();
    formData.append('selectedPage', this.newBanner.selectedPage);
    formData.append('title', this.newBanner.title);
    if (this.selectedFile) {
        formData.append('bannerImage', this.selectedFile);
    }
    try {
        const response = await fetch(`${API_BASE_URL}/banner/`, {
            method: 'POST',
            body: formData
        });
        await response.json();
        this.resetForm();
        await this.fetchCounts(); // Fetch counts first
        // Adjust currentPage if needed
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
            this.currentPage = Math.ceil(this.counts[this.activeTab] / this.limit);
        }
        await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Fetch banners with current limit
        this.imageUploaded = false;
        Swal.fire({
            icon: 'success',
            title: 'Banner Created Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
    } catch (error) {
        console.error('Error submitting banner:', error);
    } finally {
        this.isSubmitting = false;
    }
},
async deleteSelectedContacts() {
    try {
        await axios.delete(`${API_BASE_URL}/banner/bulk_delete/`, { data: { ids: this.selectedBanners } });
        this.editBannersData = this.editBannersData.filter(banner => !this.selectedBanners.includes(banner.id));
        this.selectedBanners = [];
        await this.fetchCounts(); // Update counts
        await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh banners
        if (this.editBannersData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        this.selectAll = false;
    } catch (error) {
        console.error('Error deleting contacts:', error);
    }
},
        async submitEditForm(bannerId: number) {
            if (!this.editBannerData.selectedPage || !this.editBannerData.title) {
                this.errEditMsg = 'This Field Is Required'
                return
            }
            this.isSubmitting = true;
            const formData = new FormData();
            formData.append('selectedPage', this.editBannerData.selectedPage);
            formData.append('title', this.editBannerData.title);
            if (this.selectedEditFile) {
                formData.append('bannerImage', this.selectedEditFile);
            }

            try {
                const response = await axios.patch(`${API_BASE_URL}/banner/${bannerId}/`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                this.fetchBanners();
                this.cancelEdit();
                this.editFormSubmitted = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Banner Updated Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error) {
                console.error('Error updating banner:', error);
            }  finally {
              this.isSubmitting = false;
            }
        },
        handleLimitChange() {
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
    this.selectAll = false;
    this.selectedBanners = [];
    this.fetchBanners(this.activeTab, this.limit, 0);
},
        async fetchBanners(status = 'all', limit?: number, skip = 0, sortBy = 'position') {
    const effectiveLimit = limit ?? this.limit;

    let url = `${API_BASE_URL}/banner/`;
    const params = new URLSearchParams();
    if (status === 'published') params.append('status', '1');
    else if (status === 'unpublished') params.append('status', '0');

    // Only reset currentPage for a new search, preserve limit
    if (this.searchedText && !this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = this.searchedText;
    }
    if (!this.searchedText && this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = '';
    }

    params.append('limit', effectiveLimit.toString());
    params.append('skip', skip.toString());
    if (this.searchedText) {
        params.append('searchedText', this.searchedText);
    }
    params.append('sort_by', sortBy);

    try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.editBannersData = response.data;
        this.totalPages = Math.ceil(this.counts[status] / effectiveLimit); // Update totalPages
        console.log('Banners Fetched:', this.editBannersData.length, 'Total Pages:', this.totalPages); // Debug log
        this.setupSortable();
    } catch (error) {
        console.error('Error fetching banners:', error);
    }
},
async switchView(status: string) {
    this.currentPage = 1;
    this.activeTab = status;
    this.selectedBanners = [];
    this.selectAll = false;
    this.editFormSubmitted = false;
    await this.fetchBanners(status, this.limit, 0); // Use current limit
    if (status === 'published') {
        this.totalPages = Math.ceil(this.counts.published / this.limit);
    } else if (status === 'unpublished') {
        this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
    } else {
        this.totalPages = Math.ceil(this.counts.all / this.limit);
    }
},
        removeImage() {
            this.imageSrc = '';
            this.selectedFile = null;
            this.imageUploaded = false;
        },
        cancelForm() {
            this.newBanner = {
                selectedPage: '',
                title: '',
                bannerImage: ''
            };
            this.errMsg = '';
            this.imageSrc = '';
            this.showAddForm = false;
            this.imageUploaded = false
        },
        async fetchCounts(searchedText?: string) {
    try {
        const baseUrl = `${API_BASE_URL}/banner/count/`;
        const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';

        const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
            axios.get(`${baseUrl}${queryParam}0&status=1`),
            axios.get(`${baseUrl}${queryParam}1`),
            axios.get(`${baseUrl}${queryParam}0`)
        ]);

        this.counts = {
            all: allResponse.data.count,
            published: publishedResponse.data.count,
            unpublished: unpublishedResponse.data.count
        };

        if (this.activeTab in this.counts) {
            this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit); // Use this.limit instead of 10
            console.log('Counts:', this.counts, 'Total Pages:', this.totalPages, 'Limit:', this.limit); // Debug log
        } else {
            console.error(`Invalid active tab: ${this.activeTab}`);
        }
    } catch (error) {
        console.error('Error fetching banner counts:', error);
    }
},


editBanner(index: number) {
    this.editBannersData.forEach((banner, i) => {
        banner.editing = i === index;
    });
    this.editFormSubmitted = true;
    const selectedBanner = this.editBannersData[index];
    this.editBannerData = {
        selectedPage: selectedBanner.selectedPage,
        title: selectedBanner.title,
        bannerImage: selectedBanner.bannerImage || ''
    };
    // Use getCdnImageAddress to ensure proper CDN URL
    this.editimageSrc = selectedBanner.bannerImage
        ? this.getCdnImageAddress(selectedBanner.bannerImage, 'w_200,h_100/')
        : '';
    
    if (this.sortableInstance) {
        this.sortableInstance.option('disabled', true); // Disable dragging during edit
    }
},

        resetForm() {
            this.newBanner = {
                selectedPage: '',
                title: '',
                bannerImage: ''
            };
            this.selectedFile = null;
            this.imageSrc = '';
            this.showAddForm = false;
        },

        cancelEdit() {
            this.editBannersData.forEach((banner) => {
                banner.editing = false;
            });
            this.editBannerData = {
                title: '',
                selectedPage: '',
                bannerImage: ''
            };
            this.editFormSubmitted = false;
            this.selectedEditFile = null;
            this.editimageSrc = '';
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', false); // Re-enable dragging
            }
        },

        async deleteBanner() {
    try {
        await axios.delete(`${API_BASE_URL}/banner/${this.bannerToDelete}/`);
        await this.fetchCounts(); // Update counts
        await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh banners
        if (this.editBannersData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        (this.$refs.dummyButton as HTMLElement)?.click();
    } catch (error) {
        console.error('Error deleting banner:', error);
    }
},
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },

        async changeBannerStatus(bannerId: number, newStatus: number) {
    try {
        const formData = new FormData();
        formData.append('status', newStatus.toString());

        await axios.patch(`${API_BASE_URL}/banner/${bannerId}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        await this.fetchCounts(); // Update counts
        await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh banners
        if (this.editBannersData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
    } catch (error) {
        console.error('Error updating banner status:', error);
    }
},
        useStripHtml(html : string) {
        let regex = /(<([^>]+)>)/ig;
        return html.replace(regex, "");
        },
        setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error('Sortable list ref not found!');
          return;
        }

        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }

        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: '.admin-item-box',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          filter: '.css-checkbox, button, input, select, a, .admin-item-box-btm', // Prevent dragging on edit form
          preventOnFilter: true,
          disabled: this.editFormSubmitted, // Disable when editing
          onStart: () => {
            this.isDragging = true;
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;

            if (oldIndex === newIndex) return;

            // Optimistically update local data
            const newBannersData = [...this.editBannersData];
            const [movedItem] = newBannersData.splice(oldIndex, 1);
            newBannersData.splice(newIndex, 0, movedItem);

            // Update positions locally
            newBannersData.forEach((item, index) => {
              item.position = index + 1; // 1-based positioning
            });

            // Update reactive property
            this.editBannersData = newBannersData;

            // Prepare data for backend sync
            const reorderedItems = newBannersData.map((item) => ({
              id: item.id,
              position: item.position,
            }));

            try {
              await axios.post(`${API_BASE_URL}/banner/reorder/`, {
                items: reorderedItems,
              });

              // Fetch updated data from server
              await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);

              Swal.fire({
                icon: 'success',
                title: 'Order Updated Successfully!',
                timer: 1500,
                showConfirmButton: false,
              });
            } catch (error) {
              console.error('Error updating order:', error);
              await this.fetchBanners(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
              Swal.fire({
                icon: 'error',
                title: 'Order Update Failed!',
                text: 'Reverted to last saved order.',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
        });
      });
    }
  }
});
</script>

<style scoped>
.admin-item-box {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>
